import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import store from './app/store';
import { Provider } from 'react-redux';

export const rxcWidget = {
    new: config => {
        return {
            render: () => {
                ReactDOM.render(
                    <Provider store={store}>
                        <App config={config} />
                    </Provider>,
                    document.querySelector(config.selector)
                );
            },
        };
    },
};

const configureBrand = (env, config = null) => {
    const urlParams = new URLSearchParams(window.location.search);
    const brand = urlParams.get('brand');

    if (env == 'development') {
        // Skins DEV preview
        require('./styles/rxc-dev-fonts.scss');
        require('./styles/rxc-dev-style.scss');
    }

    require('./styles/rxc-style.scss');

    if (brand) {
        require('../skins/rxc-' + brand.toLowerCase() + '.scss');

        if (config) {
            // Brand config
            switch (brand) {
                case 'glasses':
                    config.brand = 'glasses';
                    config.baseURLs = {
                        ...config.baseURLs,
                        genericImage: 'https://assets.glasses.com/extra/image/Glasses/LOGOS/rxc/',
                        projectImage: 'https://assets.glasses.com/extra/image/Glasses/LOGOS/rxc/',
                        framesImage: 'https://assets.glasses.com/is/image/Glasses',
                        assetsCDN: 'https://assets.glasses.com',
                        learnMoreBaseEndpoint: '/wcs/resources/store/15951/espot/',
                    };
                    config.unbrandedFrameImages = {
                        ...config.unbrandedFrameImages,
                        rayban: {
                            default:
                                'https://assets.glasses.com/is/image/Glasses/#PARTNUMBER#_shad_qt.png?impolicy=GL_parameters_transp',
                            unbranded:
                                'https://assets.glasses.com/extra/image/rxc/frames/#MO#__#CO#__RXP__nologo__qt.png?impolicy=GL_parameters_transp',
                            rayban:
                                'https://assets.glasses.com/is/image/Glasses/#PARTNUMBER#_shad_qt.png?impolicy=GL_parameters_transp',
                        },
                        raybanjr: {
                            default:
                                'https://assets.glasses.com/is/image/Glasses/#PARTNUMBER#_shad_qt.png?impolicy=GL_parameters_transp',
                            unbranded:
                                'https://assets.glasses.com/extra/image/rxc/frames/#MO#__#CO#__RXP__nologo__qt.png?impolicy=GL_parameters_transp',
                            rayban:
                                'https://assets.glasses.com/is/image/Glasses/#PARTNUMBER#_shad_qt.png?impolicy=GL_parameters_transp',
                        },
                        oakley: {
                            default:
                                'https://assets.glasses.com/is/image/Glasses/#PARTNUMBER#_shad_qt.png?impolicy=GL_parameters_transp',
                            unbranded:
                                'https://assets.glasses.com/is/image/Glasses/#PARTNUMBER#_shad_qt.png?impolicy=GL_parameters_transp',
                            oakley:
                                'https://assets.glasses.com/extra/image/rxc/frames/#MO#__#CO#__RXP__logo__qt.png?impolicy=GL_parameters_transp',
                        },
                        default: {
                            default:
                                'https://assets.glasses.com/is/image/Glasses/#PARTNUMBER#_shad_qt.png?impolicy=GL_parameters_transp',
                            unbranded:
                                'https://assets.glasses.com/is/image/Glasses/#PARTNUMBER#_shad_qt.png?impolicy=GL_parameters_transp',
                        },
                    };
                    config.data.frame.imageUrl =
                        'https://assets.glasses.com/is/image/Glasses/713132838167_shad_qt.png?impolicy=GL_parameters_transp';
                    config.prescriptionModule.prescriptionType = 'FULL';
                    break;
                case 'costa':
                    config.brand = 'costa';
                    window.rxcTranslations = {
                        costa: {
                            en_US: {
                                backToProductPage: 'Back to frame selection',
                                add: 'Select',
                                price: {
                                    frame: 'Total: ',
                                    frameLens: 'Total: ',
                                },
                                steps: {
                                    type: {
                                        title: 'What do you need glasses for?',
                                    },
                                    thickness: {
                                        title: 'How slim would you like your lens?',
                                    },
                                    treatments: {
                                        applyAndContinue: 'Confirm',
                                        continue: 'Confirm',
                                        antiReflective: {
                                            title: 'Anti reflective',
                                        },
                                        colorCategory: {
                                            title: 'Lens coating',
                                        },
                                    },
                                    warranty: {
                                        title: 'Summary',
                                    },
                                },
                                prescription: {
                                    toggleLabel: 'Add your values to see our lens recommendations',
                                },
                            },
                        },
                    };
                    config.translation = {
                        language: 'en_US',
                        brand: 'costa',
                    };
                    config.insuranceModule = null;
                    config.prescriptionModule.prescriptionType = 'SIMPLE';
                    break;
                case 'opsm':
                    config.brand = 'opsm';
                    config.baseURLs = {
                        ...config.baseURLs,
                        genericImage:
                            'https://assets.lenscrafters.com/extra/image/rxc/brands/opsm/',
                        framesImage: 'https://assets.glasses.com/is/image/Glasses',
                    };
                    break;
                default:
                    break;
            }
        }
    } else {
        // LC default
        if (env == 'development') {
            require('../mock/translations/translations');
        }
    }

    return config;
};

// Only DEV
if (process.env.NODE_ENV === 'development') {
    let responseMock = '/mock/lenses/eyeLensesMockResponse.json';

    // Init tealium objects
    window.tealium_data2track = window.tealium_data2track | [];
    window.utag_data = {};
    window.utag_data.Products = window.utag_data.Products | [];

    let config = require('../mock/devConfig');
    config = configureBrand(process.env.NODE_ENV, config);

    switch (process.env.MODE) {
        case 'dev.eye':
            config.data.frame = {
                catEntryId: '322532',
                name: 'RX5154 CLUBMASTER',
                upc: '713132838167',
                model: '0RX5154',
                color: '2077',
                listPrice: 400.0,
                brand: 'Ray-Ban',
                category: 'EYEGLASSES',
                imageUrl:
                    'https://assets.lenscrafters.com/is/image/LensCrafters/713132838167__002.png?imwidth=680',
                brandImageUrl:
                    'https://uat.lenscrafters.com/wcsstore/LensCraftersStorefrontAssetStore/Attachment/BRANDS/THUMBNAIL/LC_logos_120x50_Ray-ban.png',
                rxValues: {
                    // prescription power max and min values, MANDATORY for prescription filtering feature
                    powerCombinedMin: '-9.00',
                    powerCombinedMax: '9.00',
                },
            };
            config.data.frameOnlyLensUPC = '99';
            break;
        case 'dev.sun':
            config.data.frame = {
                catEntryId: '776304',
                name: 'RB1969 54 RECTANGLE',
                upc: '8056597199629',
                model: '0RB1969',
                color: '919631',
                listPrice: 154.0,
                brand: 'Ray-Ban',
                category: 'SUNGLASSES',
                imageUrl:
                    'https://assets.lenscrafters.com/is/image/LensCrafters/8056597199629__002.png?imwidth=680',
                brandImageUrl:
                    'https://uat.lenscrafters.com/wcsstore/LensCraftersStorefrontAssetStore/Attachment/BRANDS/THUMBNAIL/LC_logos_120x50_Ray-ban.png',
                rxValues: {
                    // prescription power max and min values, MANDATORY for prescription filtering feature
                    powerCombinedMin: '-9.00',
                    powerCombinedMax: '9.00',
                },
            };
            config.data.frameOnlyLensUPC = '99';

            responseMock = '/mock/lenses/sunLensesMockResponse.json';
            break;
        case 'dev.eye.gvp':
            config.data.frame = {
                catEntryId: '322532',
                name: 'RX5154 CLUBMASTER',
                upc: '713132838167',
                model: '0RX5154',
                color: '2077',
                listPrice: 400.0,
                brand: 'Ray-Ban',
                category: 'EYEGLASSES',
                imageUrl:
                    'https://assets.lenscrafters.com/is/image/LensCrafters/713132838167__002.png?imwidth=680',
                brandImageUrl:
                    'https://uat.lenscrafters.com/wcsstore/LensCraftersStorefrontAssetStore/Attachment/BRANDS/THUMBNAIL/LC_logos_120x50_Ray-ban.png',
                rxValues: {
                    // prescription power max and min values, MANDATORY for prescription filtering feature
                    powerCombinedMin: '-9.00',
                    powerCombinedMax: '9.00',
                },
            };
            config.data.frameOnlyLensUPC = '99';

            responseMock = '/mock/lenses/eyeGvpLensesMockResponse.json';
            break;
        case 'dev.sun.gvp':
            config.data.frame = {
                catEntryId: '776304',
                name: 'RB1969 54 RECTANGLE',
                upc: '8056597199629',
                model: '0RB1969',
                color: '919631',
                listPrice: 154.0,
                brand: 'Ray-Ban',
                category: 'SUNGLASSES',
                imageUrl:
                    'https://assets.lenscrafters.com/is/image/LensCrafters/8056597199629_shad_qt.png?imwidth=680',
                brandImageUrl:
                    'https://uat.lenscrafters.com/wcsstore/LensCraftersStorefrontAssetStore/Attachment/BRANDS/THUMBNAIL/LC_logos_120x50_Ray-ban.png',
                rxValues: {
                    // prescription power max and min values, MANDATORY for prescription filtering feature
                    powerCombinedMin: '-9.00',
                    powerCombinedMax: '9.00',
                },
            };
            config.data.frameOnlyLensUPC = '99';

            responseMock = '/mock/lenses/sunGvpLensesMockResponse.json';
            break;
        default:
            break;
    }

    const xobj = new XMLHttpRequest();
    xobj.overrideMimeType('application/json');
    xobj.open('GET', responseMock, true);
    xobj.onreadystatechange = function () {
        if (xobj.readyState == 4 && (xobj.status == '200' || xobj.status == '0')) {
            config.lensesData = JSON.parse(xobj.responseText);
            const myWidget = rxcWidget.new(config);
            myWidget.render();
        }
    };
    xobj.send(null);
} else {
    // Only PROD
    configureBrand(process.env.NODE_ENV);
}
